






























































































import Vue from "vue";
import Component from "vue-class-component";
import Emit from "vue-property-decorator";
import { StringHelpers } from "../../api/helpers/StringHelpers";
import { status } from "../../api/status/status";
import { workorder } from "../../api/workorder/workorder";
@Component({
  name: "WorkOrderDetails",
  props: {
    details: {
      name: "",
      issuedate: "",
      type: "",
      id: "",
      aia: "",
      comments: ""
    }
  },
  model: {
    prop: "details",
    event: "change"
  }
})
export default class WorkOrderDetails extends Vue {
  public types: any[] = [];
  public row: any;
  public async fillboxes() {
    await this.getWOTypeList();
  }
  public mounted() {
    this.row = this.$store.getters.getCurrentId;
    this.fillboxes();
    this.$emit("on-loaded");
  }
  public async getWOTypeList() {
    await workorder
      .getAllTypes(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          let i = 0;
          while (i <= JSON.parse(JSON.stringify(resp)).length - 1) {
            this.types.push({
              value: JSON.parse(JSON.stringify(resp))[i].id,
              label: JSON.parse(JSON.stringify(resp))[i].literal
            });
            i++;
          }
        });
      });
  }
}
